import { Button } from '@/components/ui/button'

type HeroProps = {
    onCTAClick: () => void
}

export const Hero = ({ onCTAClick }: HeroProps) => {
    return (
        <section id="realms" className="w-full">
            <div className="relative w-full aspect-[2/1] overflow-hidden">
                {/* Background Image */}
                <img
                    src="/hero-background.webp"
                    alt="A lush mythical landscape representing Mythkin Realms"
                    className="w-full h-full object-cover opacity-40"
                />
                {/* Dark Overlay for Better Text Readability */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60" />
                {/* Content Overlay */}
                <div className="absolute inset-0 flex items-center justify-center z-10">
                    <div className="text-center space-y-4 px-4">
                        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-foreground drop-shadow-lg">
                            Enter Mythkin Realms
                        </h1>
                        <p className="text-lg text-foreground/90 max-w-2xl drop-shadow-md">
                            Adopt, raise, and adventure with magical companions as you help shape an ever-growing
                            world
                        </p>
                        <div className="pt-2">
                            <Button
                                size="lg"
                                onClick={(e) => {
                                    e.preventDefault()
                                    onCTAClick()
                                }}
                            >
                                Get Early Access
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

